"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageSrc = imageSrc;
exports.imageAlt = imageAlt;

function imageSrc(media, src) {
  return media ? media.src : src;
}

function imageAlt(media, alt) {
  return media && media.alt ? media.alt : alt;
}